export const TranslationIdMap = '';

export const TranslationKeyMap = {
    '_7226_ALL_OPTIONS_SELECTED': 'All options selected',
    '_7204_COMPLETE': 'Complete',
    '_7223_COMPLETED': 'Completed',
    '_7211_CURRENTLY_VIEWING_': 'Currently Viewing:',
    '_965_DATE': 'Date',
    '_7219_DATE_UPDATED': 'Date Updated',
    '_7221_DRAFT': 'Draft',
    '_7213_EXPORT_DATA': 'Export Data',
    '_7202_FINAL_EDIT': 'Final Edit',
    '_42_FIRST_NAME': 'First Name',
    '_7207_GENERATE': 'Generate',
    '_7217_HIDE': 'Hide',
    '_7224_HIERARCHY': 'Hierarchy',
    '_46_LAST_NAME': 'Last Name',
    '_48_MANAGER': 'Manager',
    '_7214_MANAGER_FIRST_NAME': 'Manager First Name',
    '_7215_MANAGER_LAST_NAME': 'Manager Last Name',
    '_925_MY_TEAM': 'My Team',
    '_842_N_A': 'N/A',
    '_53_NAME': 'Name',
    '_711_NO_DATA_AVAILABLE': 'No Data Available',
    '_7413_NO_RESULTS_FOUND': 'No Results Found',
    '_7220_NOT_STARTED': 'Not Started',
    '_7222_PENDING': 'Pending',
    '_7210_PRINT': 'Print',
    '_7205_PRINT_PREVIEW': 'Print Preview',
    '_201_QUARTER': 'Quarter',
    '_7228_QUARTERLY_PERFORMANCE___DEVELOPMENT_CHECK_IN_FORM': 'Quarterly Performance & Development Check In Form',
    '_7206_REPORT': 'Report',
    '_7200_SAVE_DRAFT': 'Save Draft',
    '_7209_SELECT_QUARTERS': 'Select Quarters',
    '_994_SELECT_ALL': 'Select all',
    '_7225_SELF_REVIEW': 'Self Review',
    '_7203_SEND_BACK': 'Send Back',
    '_7218_SHOW': 'Show',
    '_7216_SORT_BY': 'Sort by',
    '_127_STATUS': 'Status',
    '_7212_STEP_HIERARCHY': 'Step Hierarchy',
    '_7201_SUBMIT': 'Submit',
    '_101_USER_ID': 'User ID',
    '_645__FIELD_LABEL__IS_A_REQUIRED_FIELD__PLEASE_SELECT_A__FIELD_LABEL_': '{{field_label}} is a required field. Please select a {{field_label}}.',
    '_7227__FIELD_LABEL__MUST_BE_LESS_THAN_OR_EQUAL_TO__REQUIREDLENGTH__CHARACTERS_': '{{field_label}} must be less than or equal to {{requiredLength}} characters.'
};
